/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./luckyBox.vue?vue&type=template&id=664a7b28&scoped=true"
import script from "./luckyBox.vue?vue&type=script&lang=js"
export * from "./luckyBox.vue?vue&type=script&lang=js"
import style0 from "./luckyBox.vue?vue&type=style&index=0&id=664a7b28&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "664a7b28",
  null
  
)

export default component.exports